import { render, staticRenderFns } from "./HistoryCurve.vue?vue&type=template&id=1ff1a76b&scoped=true&"
import script from "./HistoryCurve.vue?vue&type=script&lang=js&"
export * from "./HistoryCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff1a76b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff1a76b')) {
      api.createRecord('1ff1a76b', component.options)
    } else {
      api.reload('1ff1a76b', component.options)
    }
    module.hot.accept("./HistoryCurve.vue?vue&type=template&id=1ff1a76b&scoped=true&", function () {
      api.rerender('1ff1a76b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HistoryCurve.vue"
export default component.exports